export enum UserRoles {
  admin = 'administrator',
  commissioner = 'komisioner',
  operationDirector = 'drejtor_operacionesh',
  operationOperator = 'operator_operacionesh',
  client = 'klient',
  finance = 'finance',
  tradingDirector = 'drejtor_tregtimi',
}
